module.exports = __webpack_public_path__ + "img/gms_5.d45022c3.png";